import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { useInfiniteListWithRestore } from '../../../hooks/useInfiniteListWithRestore/useInfiniteListWithRestore';
import { OmitPaginatedEndpointParams } from '../../types';
import { getFindSalesRepresentativesKey } from './salesRepresentatives.keys';
import { findSalesRepresentatives } from './salesRepresentatives.repository';
import {
  FindSalesRepresentativesOutput,
  FindSalesRepresentativesParams,
  UseFindSalesRepresentativesConfig,
} from './salesRepresentatives.types';

export const useFindSalesRepresentatives = (
  params: FindSalesRepresentativesParams,
  options?: UseDataQueryOptions,
  { keepPreviousData }: UseFindSalesRepresentativesConfig = {},
) =>
  useDataQuery<FindSalesRepresentativesOutput>(
    {
      keepPreviousData,
      queryKey: getFindSalesRepresentativesKey(params),
      queryFn: async () => {
        const response = await findSalesRepresentatives({ 'order[name]': 'DESC', ...params });
        if (!response.ok || !response.data) {
          throw response.originalError;
        }
        return response.data;
      },
    },
    options,
  );

export const useInfiniteSalesRepresentativesList = (
  params: OmitPaginatedEndpointParams<FindSalesRepresentativesParams>,
) =>
  useInfiniteListWithRestore({
    limit: 20,
    queryKey: ['salesRepresentatives', params],
    defaultOrderBy: { name: 'ASC' },
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(findSalesRepresentatives, params),
  });
